<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <!--header-->
      <div class="nav_bar">
        <button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>
        <p class="clear_style fl nav_bar_search tc">杭州 Hello Kitty 乐园</p>
      </div>

      <!--content-->
      <div class="cart_content">
        <!--address-->
        <div v-html="content" class="content_item"></div>
        <!--idCard-->
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { cartToOrderImputedPrice,getProductPromoCodeAvailable,createOrder,login } from '@/router/api';
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import {Image,Button } from 'vant';
  import {Overlay,PullRefresh,Toast } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: 'parkInfo',
    data() {
      return {
        token:"",
        showLoading:true,
        content:this.$route.params.info,
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      footerView,
      loading,
      refresh
    },
    methods: {
      async initData() {
        setTimeout(() => {
          this.showLoading = false;
        }, 1000);
      },
    },
    mounted() {
      this.initData();
    },


  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .cart_content {
    padding: 0 1rem;
    padding-top: 2.5rem;
    padding-bottom: 3rem;
  }

  .cart_group_item {
    padding-top: 0;
  }

  .balance_view {
    height: 3rem;width: 100%;position: fixed;bottom: 0;background-color: white;box-shadow: 0px -2px 10px #F0F0F0;
  }

  .base_line {
    height: 3rem;
    background-color: white;
  }

  .content_item {
    background-color: white;padding: 0.7rem 0.5rem;;box-shadow: 0px 1px 17px #F0F0F0;border-radius: 0.2rem;margin: 1rem 0;
  }

  .animate_action {
    transition:all .4s;
  }


  .coupon_item {
    height: 7rem;
  }


</style>



// WEBPACK FOOTER //
// src/components/page/ticket/parkInfo.vue